// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textBox {
    width: 100%;
}

.validationMessage {
    display: block;
    color: red;
    position: absolute;
    font-size: 12px;
    line-height: 3;
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/textbox/textbox.control.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB","sourcesContent":[".textBox {\n    width: 100%;\n}\n\n.validationMessage {\n    display: block;\n    color: red;\n    position: absolute;\n    font-size: 12px;\n    line-height: 3;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
